import { useMemo } from "react";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import type { Field, ObjectFieldValues } from "../../../api/types/objectTypes";
import { useFilterContext } from "../../common/filters/FilterContext";
import { getEntitiesGridColumns } from "./entitiesGridDataProvider";

interface Props {
  entities: ObjectFieldValues[];
  fields: Field[];
  showLogos?: boolean;
  isLoading?: boolean;
  getDetailsPath: (id: string) => string;
}

const EntitiesGrid = ({ entities, fields, showLogos, isLoading, getDetailsPath }: Props) => {
  const { filterState } = useFilterContext<ObjectFieldValues>();

  const columns = useMemo(
    () => getEntitiesGridColumns(fields, filterState.visibleColumns, { showLogos, getDetailsPath }),
    [fields, filterState.visibleColumns, showLogos, getDetailsPath]
  );

  return (
    <DataGrid<ObjectFieldValues>
      rows={entities}
      columns={columns}
      loading={isLoading}
      disableColumnReorder
      disableColumnSorting
    />
  );
};

export default EntitiesGrid;
